import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from '../../Server'
import axios from 'axios';

import DropdownTreeSelect from 'react-dropdown-tree-select'
import 'react-dropdown-tree-select/dist/styles.css'
import swal from 'sweetalert';
import $ from 'jquery';
import MultiDropDown from '../Components/MultiDropdown';

var imgPrefix = `${SERVER_IP}/icons`
class SiteProfileCadmin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Lists: {},
            user_action: "view",
            tempList: {},
            image: "",

        }
    }


    viewInfo = () => {
        let site_info = sessionStorage.getItem('c_admin_s_profile');
        if (site_info == "") {
            return
        }
        let site_info_parse = JSON.parse(site_info);
        var data = {
            s_id: "",
            user_id: site_info_parse.login_id,
            user_type: 2
        }
        let _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/usersList`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.data.error == false) {
                    if (response.data.usersList) {
                        if (response.data.usersList.length == 1) {
                            _this.setState({ Lists: response.data.usersList[0], tempList: response.data.usersList[0], message: response.data.usersList.length === 0 ? "No Record Found." : "" });
                        }
                    }
                } else {
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.viewInfo();
                        }
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    componentDidMount() {
        this.viewInfo();

        // this.getTotalType()
        var current = this
        $(".btnrating").on('click', (function (e) {

            var previous_value = $("#selected_rating").val();

            var selected_value = $(this).attr("data-attr");
            current.setState({ rating: selected_value })
            $("#selected_rating").val(selected_value);

            $(".selected-rating").empty();
            $(".selected-rating").html(selected_value);

            for (var i = 1; i <= selected_value; ++i) {
                $("#rating-star-" + i).toggleClass('btn-warning');
                $("#rating-star-" + i).toggleClass('btn-default');
            }

            for (var ix = 1; ix <= previous_value; ++ix) {
                $("#rating-star-" + ix).toggleClass('btn-warning');
                $("#rating-star-" + ix).toggleClass('btn-default');
            }

        }));
    }
    Edit = () => {
        var data = {
            name: this.state.tempList.name,
            site_name: this.state.tempList.site_name,
            phone: this.state.tempList.phone,
            email: this.state.tempList.email,
            user_type: 1,
            address: this.state.tempList.address,
            s_id: this.state.Lists.login_id,
            main_id: this.state.Lists.id,
            city: this.state.tempList.city,
            state: this.state.tempList.state,
            details: this.state.tempList.details,
            zip: this.state.tempList.zip,
            user_id: ""
        }
        var _this = this;
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/create/c_s_edit`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.error == false) {
                        swal(response.data.message)
                        _this.viewInfo();
                        _this.setState({ user_action: "view" });
                    }else{
                        auth_response_flow(response.data, (return_response) => {
                            if (return_response.error === false && return_response.retry === true) {
                                _this.Edit();
                            }
                        })
                    }
                }
            })
            .catch(function (error) {
                swal("Something Went Wrong. Please Retry.")
            });
    }
    onChangeInput = (e) => {
        e.preventDefault();
        this.state.tempList[e.target.name] = e.target.value
        this.setState(this.state)
    }

    render() {
        
        const { errors } = this.state;
        return (
            <div>
                <div class="xp-breadcrumbbar">
                    <div class="row">
                        <div className="col-md-6">
                            <h4 class="xp-page-title">Site Profile</h4>
                        </div>
                        <div class="col-md-12 col-lg-12">
                            <div class="xp-breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><i class="icon-home"></i></a></li>
                                    <li class="breadcrumb-item active">Site Profile</li>
                                </ol>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-6 mt-4">
                            {this.state.user_action != "edit" ?
                                <button className="btn btn-primary btn-lg" title="Create new" onClick={() => this.setState({ user_action: "edit" })}><i className="mdi mdi-plus mr-2"></i>Edit Site </button>
                                :
                                <button className="btn btn-primary btn-lg" title="Create new" onClick={() => this.setState({ user_action: "view" })}><i className="fa fa-angle-left mr-2"></i>Back </button>
                            }
                        </div>
                    </div>
                    {this.state.user_action != "edit" ?
                        <div className="xp-contentbar">
                            <div className="row">
                                <div className="">
                                    <div className="card m-b-30">
                                        <div className="card-header bg-primary">
                                            <h5 className="card-title text-white">Site Profile</h5>
                                        </div>
                                        <div className="card-body">
                                            <div class="xp-social-profile-middle text-center">
                                                <div class="row">
                                                    <div class="col-12">
                                                        {/* <div class="xp-social-profile-avatar text-center">
                                                            <img src={`${imgPrefix}/${this.state.Lists.cooperate_logo}`} alt="user-profile" class="rounded-circle img-fluid" style={{ height: "200px" }} />
                                                        </div> */}
                                                        <div class="xp-social-profile-title">
                                                            <h5 class="my-1 text-black">{this.state.Lists.site_name}</h5>
                                                        </div>
                                                        <div class="xp-social-profile-subtitle">
                                                            <p class="mb-3 text-muted">{this.state.Lists.details}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <ul className="profile-list">
                                                <li><label>Name</label><p>{this.state.Lists.name}</p></li>
                                                <li><label>Email</label><p>{this.state.Lists.email}</p></li>
                                                <li><label>Phone</label><p>{this.state.Lists.phone}</p></li>
                                                <li><label>Address</label>{this.state.Lists.address}<p></p></li>
                                                <li><label>City</label><p>{this.state.Lists.city}</p></li>
                                                <li><label>State</label><p>{this.state.Lists.state}</p></li>
                                                <li><label>ZIP</label><p>{this.state.Lists.zip}</p></li>

                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className="card mt-4 mb-5">
                            <div className="card-body m-b-30">
                            <div className="form-group">
                                <label for="exampleInputEmail1">Site Name</label>
                                <input type="text" onChange={this.onChangeInput} name="site_name" className="form-control" value={this.state.tempList.site_name} placeholder="Enter Site Name" />

                            </div>
                            <div className="form-group">
                                <label for="exampleInputEmail1">Admin Person Name</label>
                                <input type="text" onChange={this.onChangeInput} name="name" className="form-control" value={this.state.tempList.name} placeholder="Enter Site Name" />

                            </div>
                            <div className="form-row">
                                <div className="form-group col-md-6">
                                    <label for="exampleInputEmail1">Phone</label>
                                    <input type="text" onChange={this.onChangeInput} name="phone" value={this.state.tempList.phone} className="form-control" placeholder="Enter Phone" />
                                </div>
                                <div className="form-group col-md-6">
                                    <label for="exampleInputEmail1">Email</label>
                                    <input type="email" onChange={this.onChangeInput} name="email" value={this.state.tempList.email} className="form-control" placeholder="Enter Email" />
                                </div>

                            </div>

                            <div className="form-row">
                                <div className="form-group col-md-6">
                                    <label for="exampleInputEmail1">City</label>
                                    <input type="text" onChange={this.onChangeInput} name="city" value={this.state.tempList.city} className="form-control" placeholder="Enter City Name" />
                                </div>
                                <div className="form-group col-md-4">
                                    <label for="exampleInputEmail1">State</label>
                                    <input type="text" onChange={this.onChangeInput} name="state" value={this.state.tempList.state} className="form-control" placeholder="Enter State Name" />
                                </div>
                                <div className="form-group col-md-2">
                                    <label for="exampleInputEmail1">ZIP</label>
                                    <input type="text" onChange={this.onChangeInput} name="zip" value={this.state.tempList.zip} className="form-control" placeholder="Enter ZIP" />
                                </div>
                            </div>
                            <div className="form-group">
                                <label for="exampleInputEmail1">Address</label>
                                <input type="text" onChange={this.onChangeInput} name="address" value={this.state.tempList.address} className="form-control" placeholder="Enter Address" />
                            </div>
                            <div className="form-group">
                                <label for="exampleInputEmail1">Details</label>
                                <input type="text" onChange={this.onChangeInput} name="details" value={this.state.tempList.details} className="form-control" placeholder="Enter Address" />
                            </div>

                            <button type="submit" onClick={this.Edit} className="btn btn-primary">Save</button>
                        </div>
                     </div>


                    }
                </div>
            </div>


        )
    }
}
export default SiteProfileCadmin

const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);
const validateForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach(
        (val) => val.length > 0 && (valid = false)
    );
    return valid;
}